export const PRODUCTION_CONTROL = '/production_control/';
